import { YandexMetrikaAbTestModule } from '@analytics/feature';
import { AsyncPipe, NgClass, NgFor, NgIf } from '@angular/common';
import { NgModule } from '@angular/core';
import {
  MobileMenuItemComponent,
  MobileMenuStepComponent,
  SdvorGenericLinkComponent,
  SdvorLinkComponent,
} from '@sdvor/shared/ui';
import { IconModule, SpinnerComponent } from '@spartacus/storefront';
import { CategoriesMenuComponent } from './categories-menu.component';
import { DesktopCategoriesMenuComponent } from './views/desktop/desktop-categories-menu.component';
import { MobileCategoriesMenuComponent } from './views/mobile/mobile-categories-menu.component';
import { OpenMobileCategoriesModule } from './views/mobile/open-mobile-categories/open-mobile-categories.module';

const components = [CategoriesMenuComponent, DesktopCategoriesMenuComponent, MobileCategoriesMenuComponent];

@NgModule({
  declarations: components,
  imports: [
    AsyncPipe,
    NgFor,
    NgIf,
    NgClass,
    SpinnerComponent,
    MobileMenuItemComponent,
    MobileMenuStepComponent,
    IconModule,
    OpenMobileCategoriesModule,
    SdvorLinkComponent,
    SdvorGenericLinkComponent,
    YandexMetrikaAbTestModule,
  ],
  exports: components,
})
export class CategoriesMenuModule {}
